var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpenseIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 24.5298H1V1.00977H13.6L17.8 5.20977V14.5002",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.19995 10.2498H13.6",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 15.2898H5.19995",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.96 6.04977H12.76V1.84977",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8 24.5298C20.1196 24.5298 22 22.6494 22 20.3298C22 18.0102 20.1196 16.1298 17.8 16.1298C15.4804 16.1298 13.6 18.0102 13.6 20.3298C13.6 22.6494 15.4804 24.5298 17.8 24.5298Z",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8 24.5298C20.1196 24.5298 22 22.6494 22 20.3298C22 18.0102 20.1196 16.1298 17.8 16.1298C15.4804 16.1298 13.6 18.0102 13.6 20.3298C13.6 22.6494 15.4804 24.5298 17.8 24.5298Z",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6396 20.3298H15.8008",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0688 18.5237L19.7992 20.2457L17.9008 22.1357",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpenseIconBlue);
export default __webpack_public_path__ + "static/media/ExpenseIconBlue.9b762bc499d7250f70f562a04005affb.svg";
export { ForwardRef as ReactComponent };